var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitterHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.50293,
    y: 0.500977,
    width: 30.998,
    height: 30.998,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.50293,
    y: 0.500977,
    width: 30.998,
    height: 30.998,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2188 9.33276H22.4676L17.5546 14.9809L23.3347 22.6653H18.8091L15.2649 18.0041L11.2086 22.6653H8.95859L14.2138 16.6238L8.66895 9.33338H13.3094L16.5133 13.5938L20.2188 9.33276ZM19.4299 21.3119H20.6759L12.6324 10.6154H11.2953L19.4299 21.3119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterHover);
export default __webpack_public_path__ + "static/media/twitter_hover.420d51a332bd3aab35286ed99828faa9.svg";
export { ForwardRef as ReactComponent };